function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var CreateNFTTemplate = require('./create-overlay.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');

/**
 * Yield until after the next paint so busy UI can render before
 * wallet/WASM work stalls the main thread. Same mechanism as Store
 * purchase-service (this overlay cannot import the Store module).
 */
function yieldForPaint() {
  return new Promise(function (resolve) {
    if (typeof requestAnimationFrame !== 'function') {
      setTimeout(resolve, 0);
      return;
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(resolve);
    });
  });
}
var CreateNFT = /*#__PURE__*/function () {
  function CreateNFT(app, mod) {
    var _app$browser,
      _this = this;
    _classCallCheck(this, CreateNFT);
    this.app = app;
    this.mod = mod;
    if (app !== null && app !== void 0 && (_app$browser = app.browser) !== null && _app$browser !== void 0 && _app$browser.addStylesheet) {
      app.browser.addStylesheet('/saito/css-imports/ui/saito-nft.css');
    }
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.help_overlay = new SaitoOverlay(this.app, this.mod);
    this.enable_deposit = false;
    this.app.connection.on('saito-nft-create-render-request', function () {
      var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _this.render(defaults);
    });
  }
  return _createClass(CreateNFT, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.defaults = defaults;
      this.reset();
      this.overlay.show(CreateNFTTemplate(this.app, this.mod, this), function () {
        if (typeof _this2.defaults.callback === 'function') {
          _this2.defaults.callback({
            status: 'cancelled'
          });
        }
      });
      var _iterator = _createForOfIteratorHelper(this.app.modules.respondTo('saito-create-nft', this.mod)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var nft_mod = _step.value;
          var _obj = nft_mod.respondTo('saito-create-nft', this.mod);
          this.module_provided_nfts.push(_obj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var typeDropdown = document.querySelector('#create-nft-type-dropdown');
      for (var z = 0; z < this.module_provided_nfts.length; z++) {
        var obj = this.module_provided_nfts[z];
        if (obj.title) {
          var opt = document.createElement('option');
          opt.value = obj["class"];
          opt.textContent = obj.title;
          typeDropdown.appendChild(opt);
        }
      }
      this.attachEvents();
      this.renderFooterActions();
      this.setDefaults();
    }

    /**
     * Modules may respondTo('saito-nft-create-footer', { type, overlay }) with
     * { text, callback } to add an action for the currently selected NFT type.
     */
  }, {
    key: "renderFooterActions",
    value: function renderFooterActions() {
      var _document$querySelect, _this$app$modules, _this$app$modules$get;
      var container = document.querySelector('.saito-nft-create .primary .footer .actions');
      if (!container) {
        return;
      }
      container.replaceChildren();
      var context = {
        type: this.nft_type || ((_document$querySelect = document.querySelector('#create-nft-type-dropdown')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value),
        overlay: this
      };
      var actions = ((_this$app$modules = this.app.modules) === null || _this$app$modules === void 0 || (_this$app$modules$get = _this$app$modules.getRespondTos) === null || _this$app$modules$get === void 0 ? void 0 : _this$app$modules$get.call(_this$app$modules, 'saito-nft-create-footer', context)) || [];
      var _iterator2 = _createForOfIteratorHelper(actions),
        _step2;
      try {
        var _loop = function _loop() {
          var action = _step2.value;
          if (!(action !== null && action !== void 0 && action.text) || typeof action.callback !== 'function') {
            return 1; // continue
          }
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'saito-button-secondary';
          button.textContent = action.text;
          button.onclick = function (event) {
            return action.callback(_objectSpread(_objectSpread({}, context), {}, {
              event: event
            }));
          };
          container.appendChild(button);
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          if (_loop()) continue;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "setDefaults",
    value: function setDefaults() {
      var _this$defaults, _this$defaults2, _this$defaults3, _this$defaults4, _this$defaults5, _this$defaults6, _this$defaults7, _this$defaults8;
      if ((_this$defaults = this.defaults) !== null && _this$defaults !== void 0 && _this$defaults.type) {
        var _this$defaults$locked;
        var dropdown = document.querySelector('#create-nft-type-dropdown');
        dropdown.value = this.defaults.type;
        dropdown.dispatchEvent(new Event('change', {
          bubbles: true
        }));
        if ((_this$defaults$locked = this.defaults.locked) !== null && _this$defaults$locked !== void 0 && _this$defaults$locked.includes('type')) {
          dropdown.disabled = true;
        }
      }
      if (typeof ((_this$defaults2 = this.defaults) === null || _this$defaults2 === void 0 ? void 0 : _this$defaults2.content) === 'string') {
        var _this$defaults$locked2;
        var content = document.querySelector('#create-nft-textarea');
        content.value = this.defaults.content;
        if ((_this$defaults$locked2 = this.defaults.locked) !== null && _this$defaults$locked2 !== void 0 && _this$defaults$locked2.includes('content')) {
          content.readOnly = true;
        }
      }
      if ((_this$defaults3 = this.defaults) !== null && _this$defaults3 !== void 0 && _this$defaults3.title) {
        var _this$defaults$locked3;
        var title = document.querySelector('.saito-nft-create .secondary input.title');
        title.value = this.defaults.title;
        if ((_this$defaults$locked3 = this.defaults.locked) !== null && _this$defaults$locked3 !== void 0 && _this$defaults$locked3.includes('title')) {
          title.readOnly = true;
        }
      }
      if ((_this$defaults4 = this.defaults) !== null && _this$defaults4 !== void 0 && _this$defaults4.description) {
        var _this$defaults$locked4;
        var description = document.querySelector('.saito-nft-create .secondary textarea.description');
        description.value = this.defaults.description;
        if ((_this$defaults$locked4 = this.defaults.locked) !== null && _this$defaults$locked4 !== void 0 && _this$defaults$locked4.includes('description')) {
          description.readOnly = true;
        }
      }
      if ((_this$defaults5 = this.defaults) !== null && _this$defaults5 !== void 0 && _this$defaults5.image) {
        this.image = this.defaults.image;
        if (this.supportsThumbnail()) {
          this.renderThumbnail();
        } else {
          this.addImage(this.defaults.image);
        }
      }

      //
      // Module-provided file types may receive a pre-selected file from the
      // calling UI (data URI / payload). Applied after type so upload chrome
      // matches the selected module capability.
      //
      if ((_this$defaults6 = this.defaults) !== null && _this$defaults6 !== void 0 && _this$defaults6.file) {
        this.file = this.defaults.file;
        this.show_selected_file(this.defaults.file_name || 'Selected file');
      }
      if ((_this$defaults7 = this.defaults) !== null && _this$defaults7 !== void 0 && _this$defaults7.quantity) {
        var _this$defaults$locked5;
        var amount = document.querySelector('#create-nft-amount');
        amount.value = String(this.defaults.quantity);
        if ((_this$defaults$locked5 = this.defaults.locked) !== null && _this$defaults$locked5 !== void 0 && _this$defaults$locked5.includes('quantity')) {
          amount.readOnly = true;
        }
      }
      if ((_this$defaults8 = this.defaults) !== null && _this$defaults8 !== void 0 && _this$defaults8.deposit) {
        var _this$defaults$locked6;
        var deposit = document.querySelector('#create-nft-deposit');
        deposit.value = String(this.defaults.deposit);
        if ((_this$defaults$locked6 = this.defaults.locked) !== null && _this$defaults$locked6 !== void 0 && _this$defaults$locked6.includes('deposit')) {
          deposit.readOnly = true;
        }
      }
    }
  }, {
    key: "return_module_nft",
    value: function return_module_nft() {
      for (var z = 0; z < this.module_provided_nfts.length; z++) {
        var _modobj$class;
        var modobj = this.module_provided_nfts[z];
        if (modobj !== null && modobj !== void 0 && (_modobj$class = modobj["class"]) !== null && _modobj$class !== void 0 && _modobj$class.includes(this.nft_type)) {
          return modobj;
        }
      }
      return null;
    }
  }, {
    key: "supportsThumbnail",
    value: function supportsThumbnail() {
      return ['text', 'json', 'css', 'js'].includes(this.nft_type);
    }
  }, {
    key: "renderThumbnail",
    value: function renderThumbnail() {
      var picker = document.querySelector('.create-nft-thumbnail-picker');
      if (!picker) {
        return;
      }
      picker.style.display = this.supportsThumbnail() ? 'flex' : 'none';
      picker.replaceChildren();
      if (this.image) {
        var image = document.createElement('img');
        image.src = this.image;
        image.alt = 'NFT thumbnail';
        picker.appendChild(image);
        picker.classList.add('has-image');
        picker.setAttribute('aria-label', 'Replace thumbnail');
        picker.title = 'Replace thumbnail';
        return;
      }
      var label = document.createElement('span');
      label.textContent = 'add thumbnail';
      picker.appendChild(label);
      picker.classList.remove('has-image');
      picker.setAttribute('aria-label', 'add thumbnail');
      picker.removeAttribute('title');
    }
  }, {
    key: "apply_upload_presentation",
    value: function apply_upload_presentation() {
      var modobj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var upload_el = document.querySelector('#nft-image-upload');
      if (!upload_el) {
        return;
      }
      var hint = upload_el.querySelector('.upload-hint');
      var icon = upload_el.querySelector('i');
      if (hint) {
        hint.textContent = (modobj === null || modobj === void 0 ? void 0 : modobj.upload_text) || 'drag-and-drop image to upload';
      }
      if (icon) {
        icon.className = (modobj === null || modobj === void 0 ? void 0 : modobj.upload_icon) || 'fa-solid fa-file-image';
      }
    }
  }, {
    key: "escape_html",
    value: function escape_html() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    //
    // Non-image acknowledgment for module-provided file types.
    // Does not treat the payload as an image.
    //
  }, {
    key: "show_selected_file",
    value: function show_selected_file() {
      var _document$querySelect2, _document$querySelect3;
      var file_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Selected file';
      (_document$querySelect2 = document.querySelector('.saito-nft-create .upload .file')) === null || _document$querySelect2 === void 0 || _document$querySelect2.remove();
      (_document$querySelect3 = document.querySelector('.saito-nft-create .upload .preview')) === null || _document$querySelect3 === void 0 || _document$querySelect3.remove();
      var html = "\n      <div class=\"file selected\">\n        <i class=\"fa-solid fa-check\" aria-hidden=\"true\"></i>\n        <div class=\"file-name\">".concat(this.escape_html(file_name), "</div>\n      </div>\n    ");
      this.app.browser.addElementToSelector(html, '.saito-nft-create .upload');
      var upload_el = document.querySelector('#nft-image-upload');
      if (upload_el) {
        upload_el.style.display = 'none';
      }
    }
  }, {
    key: "createObject",
    value: function () {
      var _createObject = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var obj, processed, z, modobj, _this$defaults9, title_el, title, desc_field, description, _text, _text2, tmpobj, _text3, _text4, _t, _t2, _t3, _t4, _t5;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              obj = {};
              this.nft_type = document.querySelector('#create-nft-type-dropdown').value;
              processed = false;
              z = 0;
            case 1:
              if (!(z < this.module_provided_nfts.length)) {
                _context.n = 9;
                break;
              }
              _context.p = 2;
              modobj = this.module_provided_nfts[z];
              if (!modobj["class"].includes(this.nft_type)) {
                _context.n = 6;
                break;
              }
              if (!modobj.createData) {
                _context.n = 5;
                break;
              }
              title_el = document.querySelector('.saito-nft-create .secondary input.title');
              title = ((title_el === null || title_el === void 0 ? void 0 : title_el.value) || (title_el === null || title_el === void 0 ? void 0 : title_el.getAttribute('placeholder')) || '').trim();
              desc_field = document.querySelector('.saito-nft-create .secondary textarea.description');
              description = ((desc_field === null || desc_field === void 0 ? void 0 : desc_field.value) || '').trim(); // Caller context (e.g. Store rental file_id/duration) via defaults.create_data.
              _context.n = 3;
              return modobj.createData(this.file, _objectSpread({
                title: title,
                description: description,
                image: this.image
              }, ((_this$defaults9 = this.defaults) === null || _this$defaults9 === void 0 ? void 0 : _this$defaults9.create_data) || {}));
            case 3:
              obj = _context.v;
              if (!(obj === false)) {
                _context.n = 4;
                break;
              }
              return _context.a(2, false);
            case 4:
              // Module types often need a presentation image alongside createData fields.
              if (this.image && obj && _typeof(obj) === 'object' && !Array.isArray(obj) && obj.image == null) {
                obj.image = this.image;
              }
              processed = true;
              _context.n = 6;
              break;
            case 5:
              obj.text = text;
              processed = true;
            case 6:
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t = _context.v;
              console.error('CreateNFT: custom NFT type failed', _t);
              return _context.a(2, false);
            case 8:
              z++;
              _context.n = 1;
              break;
            case 9:
              if (!(this.nft_type === 'text' && processed == false)) {
                _context.n = 13;
                break;
              }
              _text = document.querySelector('#create-nft-textarea').value;
              _context.p = 10;
              obj.text = _text;
              _context.n = 12;
              break;
            case 11:
              _context.p = 11;
              _t2 = _context.v;
              salert('Provide parseable TEXT to create NFT');
              return _context.a(2, false);
            case 12:
              processed = true;
            case 13:
              if (this.nft_type === 'token' && processed == false) {
                if (this.image) {
                  obj.image = this.image;
                }
                processed = true;
              }
              if (!(this.nft_type === 'json' && processed == false)) {
                _context.n = 17;
                break;
              }
              _text2 = document.querySelector('#create-nft-textarea').value;
              _context.p = 14;
              tmpobj = JSON.parse(_text2);
              if (tmpobj.text) {
                obj = tmpobj.text;
              } else {
                obj = tmpobj;
              }
              _context.n = 16;
              break;
            case 15:
              _context.p = 15;
              _t3 = _context.v;
              salert('Provide a valid JSON to create NFT');
              return _context.a(2, false);
            case 16:
              processed = true;
            case 17:
              if (!(this.nft_type === 'css' && processed == false)) {
                _context.n = 21;
                break;
              }
              _text3 = document.querySelector('#create-nft-textarea').value;
              _context.p = 18;
              obj.css = _text3;
              _context.n = 20;
              break;
            case 19:
              _context.p = 19;
              _t4 = _context.v;
              salert('Provide parseable TEXT to create NFT');
              return _context.a(2, false);
            case 20:
              processed = true;
            case 21:
              if (!(this.nft_type === 'js' && processed == false)) {
                _context.n = 25;
                break;
              }
              _text4 = document.querySelector('#create-nft-textarea').value;
              _context.p = 22;
              obj.js = _text4;
              _context.n = 24;
              break;
            case 23:
              _context.p = 23;
              _t5 = _context.v;
              salert('Provide parseable JS to create NFT');
              return _context.a(2, false);
            case 24:
              processed = true;
            case 25:
              if (!(this.nft_type == 'image' && processed == false)) {
                _context.n = 27;
                break;
              }
              if (this.image) {
                _context.n = 26;
                break;
              }
              salert("Attach an image/file to create nft");
              return _context.a(2, false);
            case 26:
              obj.image = this.image;
              processed = true;
            case 27:
              if (this.image && this.supportsThumbnail()) {
                if (!obj || _typeof(obj) !== 'object' || Array.isArray(obj)) {
                  obj = {
                    value: obj
                  };
                }
                obj.image = this.image;
              }
              return _context.a(2, obj);
          }
        }, _callee, this, [[22, 23], [18, 19], [14, 15], [10, 11], [2, 7]]);
      }));
      function createObject() {
        return _createObject.apply(this, arguments);
      }
      return createObject;
    }()
  }, {
    key: "enableDepositInput",
    value: function enableDepositInput() {
      var amountInput = document.getElementById('create-nft-amount');
      var depositInput = document.getElementById('create-nft-deposit');
      var depositWrap = document.getElementById('create-nft-deposit-wrap');
      if (!amountInput || !depositInput) return;

      //
      // Auto deposit (readonly, synced)
      //
      if (!this.enable_deposit) {
        // Locked: same Saito input appearance; editing disabled via readonly only
        depositInput.setAttribute('readonly', 'readonly');
        depositWrap === null || depositWrap === void 0 || depositWrap.classList.add('is-locked');

        //
        // Attach sync listener
        //
        if (this._amountSyncListener) {
          amountInput.removeEventListener('input', this._amountSyncListener);
        }
        this._amountSyncListener = function () {
          var val = this.value.replace(/[^\d]/g, '');
          if (val.includes('.')) {
            val = val.split('.')[0];
          }
          this.value = val;
          depositInput.value = val || '0';
        };
        amountInput.addEventListener('input', this._amountSyncListener);

        // Force sync immediately
        depositInput.value = amountInput.value || '0';
      }
      //
      // Manual deposit
      //
      else {
        depositInput.removeAttribute('readonly');
        depositWrap === null || depositWrap === void 0 || depositWrap.classList.remove('is-locked');

        //
        // Remove sync listener
        //
        if (this._amountSyncListener) {
          amountInput.removeEventListener('input', this._amountSyncListener);
          this._amountSyncListener = null;
        }
      }
    }
  }, {
    key: "openDepositHelpOverlay",
    value: function openDepositHelpOverlay() {
      var _this3 = this;
      this.help_overlay.show("\n      <form class=\"saito-overlay-form create-nft-help-overlay\">\n        <div class=\"saito-overlay-form-header\">\n          <div class=\"saito-overlay-form-header-title\">Deposit</div>\n        </div>\n        <div class=\"saito-overlay-form-text\">\n          <p>SAITO deposits circulate within assets and can be recovered by destroying the NFT. Changing the deposit amount may affect the persistence of the NFT on the network. Custom deposits are recommended for advanced users only.</p>\n        </div>\n        <label class=\"create-nft-deposit-container\" for=\"create-nft-enable-deposit\">\n          <input id=\"create-nft-enable-deposit\" type=\"checkbox\" class=\"saito-checkbox\" />\n          <span>Let me manually specify the deposit</span>\n        </label>\n      </form>\n    ");
      var cbox = document.querySelector('#create-nft-enable-deposit');
      if (!cbox) {
        return;
      }
      cbox.checked = this.enable_deposit;
      cbox.onchange = function () {
        if (!cbox.checked) {
          _this3.enable_deposit = false;
          _this3.enableDepositInput();
          return;
        }
        _this3.enable_deposit = true;
        _this3.enableDepositInput();
        _this3.help_overlay.close();
        var depositInput = document.getElementById('create-nft-deposit');
        if (depositInput) {
          requestAnimationFrame(function () {
            depositInput.focus({
              preventScroll: true
            });
            if (typeof depositInput.select === 'function') {
              depositInput.select();
            }
          });
        }
      };
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this4 = this;
      this.enableDepositInput();
      var depositInput = document.getElementById('create-nft-deposit');
      var depositWrap = document.getElementById('create-nft-deposit-wrap');
      if (depositInput && depositWrap) {
        var openIfLocked = function openIfLocked(e) {
          if (_this4.enable_deposit || !depositInput.hasAttribute('readonly')) {
            return;
          }
          e.preventDefault();
          _this4.openDepositHelpOverlay();
        };
        depositWrap.addEventListener('click', openIfLocked);
        depositInput.addEventListener('keydown', function (e) {
          if (_this4.enable_deposit || !depositInput.hasAttribute('readonly')) {
            return;
          }
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            _this4.openDepositHelpOverlay();
          }
        });
      }

      // Upload
      this.app.browser.addDragAndDropFileUploadToElement('nft-image-upload', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(file, _is_drag, native_file) {
          var modobj, file_name, _document$querySelect4, _document$querySelect5, _t6;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                modobj = _this4.return_module_nft();
                if (!(modobj !== null && modobj !== void 0 && modobj.createData)) {
                  _context2.n = 3;
                  break;
                }
                _this4.file = file;
                file_name = (native_file === null || native_file === void 0 ? void 0 : native_file.name) || 'Selected file'; // Optional module hook — generic UI does not import modules.
                if (!(typeof modobj.on_file_selected === 'function')) {
                  _context2.n = 1;
                  break;
                }
                _context2.n = 1;
                return modobj.on_file_selected(file, {
                  file_name: file_name
                });
              case 1:
                if (!(file && _this4.isImageDataUri(file))) {
                  _context2.n = 2;
                  break;
                }
                _this4.image = file;
                (_document$querySelect4 = document.querySelector('.saito-nft-create .upload .file')) === null || _document$querySelect4 === void 0 || _document$querySelect4.remove();
                (_document$querySelect5 = document.querySelector('.saito-nft-create .upload .preview')) === null || _document$querySelect5 === void 0 || _document$querySelect5.remove();
                _this4.addImage(file);
                return _context2.a(2);
              case 2:
                _this4.show_selected_file(file_name);
                return _context2.a(2);
              case 3:
                if (!_this4.supportsThumbnail()) {
                  _context2.n = 8;
                  break;
                }
                if (!(!file || !_this4.isImageDataUri(file))) {
                  _context2.n = 4;
                  break;
                }
                salert('Select a valid image for the NFT thumbnail');
                return _context2.a(2);
              case 4:
                _context2.p = 4;
                _context2.n = 5;
                return _this4.app.browser.resizeImg(file, 128, {
                  w: 512,
                  h: 512
                });
              case 5:
                _this4.image = _context2.v;
                _this4.renderThumbnail();
                _context2.n = 7;
                break;
              case 6:
                _context2.p = 6;
                _t6 = _context2.v;
                console.error('CreateNFT: thumbnail resize failed', _t6);
                salert('Unable to process the selected thumbnail');
              case 7:
                return _context2.a(2);
              case 8:
                if (!_this4.image) {
                  _context2.n = 9;
                  break;
                }
                salert('NFT Image Editing not allowed, refresh to restart...');
                return _context2.a(2);
              case 9:
                _this4.image = file;
                _this4.addImage(file);
              case 10:
                return _context2.a(2);
            }
          }, _callee2, null, [[4, 6]]);
        }));
        return function (_x, _x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }(), true);
      var thumbnailPicker = document.querySelector('.create-nft-thumbnail-picker');
      if (thumbnailPicker) {
        thumbnailPicker.onclick = function () {
          var input = document.querySelector('#hidden_file_element_nft-image-upload');
          if (!input) {
            return;
          }
          input.accept = 'image/*';
          input.multiple = false;
          input.value = '';
          input.click();
        };
      }

      // NFT Type
      document.querySelector('#create-nft-type-dropdown').onchange = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
          var _document$querySelect6, _document$querySelect7;
          var uploadEl, textarea, processed, modobj;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _this4.nft_type = e.target.value;
                uploadEl = document.querySelector('#nft-image-upload');
                textarea = document.querySelector('#create-nft-textarea');
                (_document$querySelect6 = document.querySelector('.saito-nft-create .upload .file')) === null || _document$querySelect6 === void 0 || _document$querySelect6.remove();
                (_document$querySelect7 = document.querySelector('.saito-nft-create .upload .preview')) === null || _document$querySelect7 === void 0 || _document$querySelect7.remove();
                processed = false; //alert(this.nft_type + ' ... ');
                if (_this4.nft_type === 'text') {
                  _this4.apply_upload_presentation();
                  uploadEl.style.display = 'none';
                  textarea.style.display = 'flex';
                  textarea.innerHTML = 'provide text or markdown';
                }
                if (_this4.nft_type === 'token') {
                  _this4.apply_upload_presentation({
                    upload_text: 'upload token logo/image (optional)'
                  });
                  document.querySelector('.saito-nft-create .secondary .label.ticker').style.display = 'block';
                  document.querySelector('.saito-nft-create .secondary input.ticker').style.display = 'block';
                  uploadEl.style.display = 'flex';
                  textarea.style.display = 'none';
                }
                if (_this4.nft_type === 'js') {
                  _this4.apply_upload_presentation();
                  uploadEl.style.display = 'none';
                  textarea.style.display = 'flex';
                  textarea.innerHTML = 'await salert("Hello World!");';
                }
                if (_this4.nft_type === 'css') {
                  _this4.apply_upload_presentation();
                  uploadEl.style.display = 'none';
                  textarea.style.display = 'flex';
                  textarea.innerHTML = '--saito-primary: green;';
                }
                if (_this4.nft_type === 'json') {
                  _this4.apply_upload_presentation();
                  uploadEl.style.display = 'none';
                  textarea.style.display = 'flex';
                  textarea.innerHTML = JSON.stringify({
                    key1: 'value1',
                    key2: 'value2'
                  }, null, 2);
                }
                if (_this4.nft_type === 'image') {
                  _this4.apply_upload_presentation();
                  uploadEl.style.display = 'flex';
                  textarea.style.display = 'none';
                }
                if (_this4.nft_type === 'file') {
                  _this4.apply_upload_presentation();
                  uploadEl.style.display = 'flex';
                  textarea.style.display = 'none';
                }
                modobj = _this4.return_module_nft();
                if (modobj) {
                  if (modobj.json) {
                    _this4.apply_upload_presentation(modobj);
                    uploadEl.style.display = 'none';
                    textarea.style.display = 'block';
                    textarea.innerHTML = JSON.stringify(modobj.json, null, 2);
                  }
                  if (modobj.createData) {
                    _this4.apply_upload_presentation(modobj);
                    uploadEl.style.display = 'flex';
                    textarea.style.display = 'none';
                  }
                }
                _this4.renderThumbnail();
                if (_this4.image && uploadEl && !_this4.supportsThumbnail()) {
                  _this4.addImage(_this4.image);
                }
                _this4.renderFooterActions();
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x4) {
          return _ref2.apply(this, arguments);
        };
      }();

      // Wizard Navigation
      var nextStep = document.getElementById('next-step');
      if (nextStep) {
        nextStep.onclick = function () {
          var root = document.querySelector('.saito-nft-create');
          if (root) {
            root.classList.add('provide-metadata');
          }
          var titleEl = document.getElementById('create-nft-overlay-title');
          if (titleEl) {
            titleEl.textContent = 'Provide Metadata';
          }
        };
      }
      var backBtn = document.getElementById('back-btn');
      if (backBtn) {
        backBtn.onclick = function () {
          var root = document.querySelector('.saito-nft-create');
          if (root) {
            root.classList.remove('provide-metadata');
          }
          var titleEl = document.getElementById('create-nft-overlay-title');
          if (titleEl) {
            titleEl.textContent = 'Create NFT';
          }
        };
      }

      // Create NFT
      document.querySelector('#create_nft').onclick = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
          var btn, restore, obj, numNFT, balance, depositAmt, fee, tx_msg, ticker, title_el, title, desc_field, description, publickey, newtx, _t7;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.p = _context4.n) {
              case 0:
                btn = e.currentTarget;
                if (!(!btn || btn.disabled)) {
                  _context4.n = 1;
                  break;
                }
                return _context4.a(2);
              case 1:
                restore = function restore() {
                  btn.disabled = false;
                  btn.removeAttribute('aria-busy');
                  btn.textContent = 'Confirm';
                };
                btn.disabled = true;
                btn.setAttribute('aria-busy', 'true');
                btn.innerHTML = '<i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Minting…';
                _context4.n = 2;
                return yieldForPaint();
              case 2:
                _context4.n = 3;
                return _this4.createObject();
              case 3:
                obj = _context4.v;
                if (!(obj == false)) {
                  _context4.n = 4;
                  break;
                }
                restore();
                return _context4.a(2);
              case 4:
                //
                // this value is not either nolan/saito
                // this represents the number of nft to mint
                //
                numNFT = parseInt(document.querySelector('#create-nft-amount').value);
                if (!(numNFT < 1)) {
                  _context4.n = 5;
                  break;
                }
                restore();
                salert('Need to create at least one NFT');
                return _context4.a(2);
              case 5:
                if (!(numNFT > 100000000)) {
                  _context4.n = 6;
                  break;
                }
                restore();
                salert('Cannot mint more than 100,000,000 NFTs');
                return _context4.a(2);
              case 6:
                _context4.n = 7;
                return _this4.app.wallet.getBalance();
              case 7:
                balance = _context4.v;
                if (!(balance === 0n)) {
                  _context4.n = 8;
                  break;
                }
                restore();
                siteMessage('SAITO tokens are required to create NFTs...', 3000);
                _this4.app.connection.emit('saito-purchase-launch');
                return _context4.a(2);
              case 8:
                // value of nft (nolan)
                depositAmt = parseInt(document.querySelector('#create-nft-deposit').value);
                depositAmt = BigInt(_this4.app.wallet.convertSaitoToNolan(depositAmt));
                if (!(balance < depositAmt)) {
                  _context4.n = 9;
                  break;
                }
                restore();
                salert('Insufficient funds!');
                return _context4.a(2);
              case 9:
                if (!(depositAmt < BigInt(1))) {
                  _context4.n = 10;
                  break;
                }
                restore();
                salert("Need at least 1 SAITO to create NFT");
                return _context4.a(2);
              case 10:
                fee = BigInt(0n);
                tx_msg = {
                  data: obj
                };
                ticker = (document.querySelector('.saito-nft-create .secondary input.ticker').value || '').toUpperCase();
                title_el = document.querySelector('.saito-nft-create .secondary input.title');
                title = title_el.value || title_el.getAttribute('placeholder') || '';
                title = title.trim();
                desc_field = document.querySelector('.saito-nft-create .secondary textarea.description');
                description = (desc_field === null || desc_field === void 0 ? void 0 : desc_field.innerText) || (desc_field === null || desc_field === void 0 ? void 0 : desc_field.value) || desc_field.innerHTML || '';
                description = description.trim();
                if (ticker) {
                  tx_msg.ticker = ticker;
                  _this4.nft_type = 'token';
                }
                if (title) {
                  tx_msg.title = title;
                }
                if (description) {
                  tx_msg.description = description;
                }
                _context4.p = 11;
                _context4.n = 12;
                return _this4.app.wallet.getPublicKey();
              case 12:
                publickey = _context4.v;
                _context4.n = 13;
                return _this4.app.wallet.createMintNFTTransaction(BigInt(numNFT), depositAmt, tx_msg, fee, publickey, _this4.nft_type);
              case 13:
                newtx = _context4.v;
                _context4.n = 14;
                return newtx.sign();
              case 14:
                _context4.n = 15;
                return _this4.app.network.propagateTransaction(newtx);
              case 15:
                if (typeof _this4.defaults.callback === 'function') {
                  _this4.defaults.callback({
                    status: 'created',
                    tx: newtx,
                    signature: newtx.signature,
                    nft_id: _this4.app.wallet.computeNFTIdFromTx(newtx)
                  });
                  _this4.defaults.callback = null;
                }
                _context4.n = 17;
                break;
              case 16:
                _context4.p = 16;
                _t7 = _context4.v;
                console.error('CreateNFT: mint failed', _t7);
                restore();
                siteMessage('Failed to mint NFT. Please try again.', 3000);
                return _context4.a(2);
              case 17:
                _this4.overlay.close();
              case 18:
                return _context4.a(2);
            }
          }, _callee4, null, [[11, 16]]);
        }));
        return function (_x5) {
          return _ref3.apply(this, arguments);
        };
      }();
    }
  }, {
    key: "addImage",
    value: function addImage() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var fileInfo = this.parseFileInfo(data);
      var html = "";
      if (fileInfo.isImage) {
        html = "<div class=\"preview\">\n                      <img src=\"".concat(data, "\" alt=\"\" />\n              </div>");
      } else {
        html = "\n                <div class=\"file\">\n                    <div class=\"file-transfer-progress\"></div>\n                    <i class=\"fa-solid fa-file-export\"></i>\n                    <div class=\"file-name\">".concat(fileInfo.name, "</div>\n                    <div class=\"file-size fixed-width\">").concat(fileInfo.size / 1024, " KB</div>\n                </div>\n            ");
      }
      this.app.browser.addElementToSelector(html, '.saito-nft-create .primary .upload');
      document.querySelector('#nft-image-upload').style.display = 'none';
    }

    // Utilities for processing a file...
  }, {
    key: "parseDataUri",
    value: function parseDataUri(dataUri) {
      var _dataUri$split = dataUri.split(',', 2),
        _dataUri$split2 = _slicedToArray(_dataUri$split, 2),
        header = _dataUri$split2[0],
        data = _dataUri$split2[1];
      if (!header.startsWith('data:')) {
        throw new Error('Not a valid data URI');
      }
      // strip leading "data:"
      var parts = header.slice(5).split(';');
      var mediaType = parts[0] || '';
      var params = {};
      for (var i = 1; i < parts.length; i++) {
        var _parts$i$split = parts[i].split('='),
          _parts$i$split2 = _slicedToArray(_parts$i$split, 2),
          key = _parts$i$split2[0],
          val = _parts$i$split2[1];
        // treat bare "base64" as a boolean flag
        params[key] = val === undefined ? '' : val;
      }
      return {
        mediaType: mediaType,
        params: params,
        data: data
      };
    }
  }, {
    key: "extractMediaType",
    value: function extractMediaType(dataUri) {
      try {
        return this.parseDataUri(dataUri).mediaType || null;
      } catch (_unused) {
        return null;
      }
    }
  }, {
    key: "extractExtension",
    value: function extractExtension(dataUri) {
      var mediaType = this.extractMediaType(dataUri);
      if (!mediaType) return null;
      var parts = mediaType.split('/');
      if (parts.length !== 2) return null;
      // drop any "+suffix" (e.g. "svg+xml" → "svg")
      return parts[1].split('+')[0].toLowerCase();
    }
  }, {
    key: "extractFileName",
    value: function extractFileName(dataUri) {
      try {
        var _this$parseDataUri = this.parseDataUri(dataUri),
          params = _this$parseDataUri.params;
        // look for either "name" or "filename"
        var fname = params.name || params.filename;
        if (fname) return fname;
        var ext = this.extractExtension(dataUri) || 'bin';
        return "file.".concat(ext);
      } catch (_unused2) {
        return null;
      }
    }
  }, {
    key: "getFileSizeFromDataUri",
    value: function getFileSizeFromDataUri(dataUri) {
      try {
        var base64 = this.parseDataUri(dataUri).data;
        // count padding characters ("=" at end)
        var paddingMatches = base64.match(/=+$/);
        var padding = paddingMatches ? paddingMatches[0].length : 0;
        // formula: bytes = 3/4 * length_of_base64 - padding
        return Math.round(base64.length * 3 / 4 - padding);
      } catch (_unused3) {
        return null;
      }
    }
  }, {
    key: "isImageDataUri",
    value: function isImageDataUri(dataUri) {
      var mt = this.extractMediaType(dataUri);
      return mt !== null && mt.startsWith('image/');
    }
  }, {
    key: "parseFileInfo",
    value: function parseFileInfo(dataUri) {
      return {
        mediaType: this.extractMediaType(dataUri),
        extension: this.extractExtension(dataUri),
        name: this.extractFileName(dataUri),
        size: this.getFileSizeFromDataUri(dataUri),
        isImage: this.isImageDataUri(dataUri)
      };
    }
  }, {
    key: "reset",
    value: function reset() {
      this.image = '';
      this.nft_type = null;
      this.module_provided_nfts = [];
      this.file = null;
      this.enable_deposit = false;
    }
  }]);
}();
module.exports = CreateNFT;